import Keycloak from 'keycloak-js';
import keys from '../config/keys';

export default new Keycloak({
  realm: keys.KEYCLOAK_REALM,
  url: keys.KEYCLOAK_URL,
  clientId: keys.KEYCLOAK_CLIENT_ID,
});
